import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import './CallSummary.css';

const CallSummary = ({ transcript, callSummary }) => {
  return (
    <Box className="component-summary">
      <Typography className="title">
        Call Summary
      </Typography>
      {callSummary || transcript ? (
        <TextField
          className="text-field"
          multiline
          rows={16}
          value={callSummary || transcript}
          variant="outlined"
        />
      ) : (
        <Typography className="no-summary">
          No summary detected
        </Typography>
      )}
    </Box>
  );
};

export default CallSummary;
